import React, { createContext, useContext, useState } from 'react';

interface AutopilotContextType {
  isEnabled: boolean;
  toggleAutopilot: () => void;
}

const AutopilotContext = createContext<AutopilotContextType | undefined>(undefined);

export function AutopilotProvider({ children }: { children: React.ReactNode }) {
  const [isEnabled, setIsEnabled] = useState(true);

  const toggleAutopilot = () => {
    setIsEnabled(prev => !prev);
  };

  return (
    <AutopilotContext.Provider value={{ isEnabled, toggleAutopilot }}>
      {children}
    </AutopilotContext.Provider>
  );
}

export function useAutopilot() {
  const context = useContext(AutopilotContext);
  if (context === undefined) {
    throw new Error('useAutopilot must be used within an AutopilotProvider');
  }
  return context;
}